import { useSuspenseQuery } from '@tanstack/react-query';

import { AnnualReportOverviewBox } from '@/module/AnnualReport/AnnualReportOverview';
import { getAnnualReportOptions } from '@/module/AnnualReport/model/AnnualReportQuery';

import { NoContentPlaceholder } from '@/core/components';

import { Id } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

interface UserAdminReportProps {
  userId: Id;
  year: number;
  validationStatus: ValidationStatus | null;
}

export function UserAdminReport({ userId, year, validationStatus }: UserAdminReportProps) {
  const {
    data: { medicalFaculties, techFaculties },
  } = useSuspenseQuery(getAnnualReportOptions(year, userId, validationStatus));

  const faculties = [...medicalFaculties, ...techFaculties];
  const disciplineOverview = faculties[0].departments[0].disciplines[0];

  return (
    <>
      {disciplineOverview != null && (
        <AnnualReportOverviewBox
          overview={disciplineOverview.overview}
          year={year}
        />
      )}
      {disciplineOverview == null && <NoContentPlaceholder title="Nu exista date" />}
    </>
  );
}
